// extracted by mini-css-extract-plugin
export default {"image":"EmptyList_image__v-BHh","max":"EmptyList_max__6FUHU","circles":"EmptyList_circles__WHoN5"};